$(document).ready(function() {
	if ($("#map").length) {
		// Set the variables and constants
		var clickNumber = 0;
		var apiURL = "";
		var collectionDefaultSet = false;
		const mapInterval = 5000;

		// Get the Mapbox Access Token from the Settings Table
		$.ajax({
			type: "GET",
			url: "/admin/settings/mapbox-api",
			datatype: "json",
			async: false,
			success: function (data) {
				mapboxgl.accessToken = data;
			}
		});
		
		// Get the URL for API routes
		$.ajax({
			type: "GET",
			url: "/admin/settings/api-address",
			datatype: "json",
			async: false,
			success: function (data) {
				apiURL = data;
			}
		});

		// Get Coordinates
		var collection_longitude 	= $("input[name='collection_longitude']");
		var collection_latitude 	= $("input[name='collection_latitude']");
		var dropoff_longitude 		= $("input[name='dropoff_longitude']");
		var dropoff_latitude 		= $("input[name='dropoff_latitude']");

		// Calculate the best zoom
		var zoom = $("#map").hasClass("report") ? 12 : 5;

		// Declare Mapbox
		var map = new mapboxgl.Map({
			container: "map",
			style: "mapbox://styles/mapbox/streets-v9",
			center: [25, -30],
			zoom: zoom,
			dragPan: true
		});

		// Declare a Popup
		var popup = new mapboxgl.Popup({
			closeButton: false,
			closeOnClick: false
		});

		// Options for the Geocoder
		var options = {
			accessToken: mapboxgl.accessToken,
			country: "za"
		};

		// Limits for Reverse Geocoder
		var limits = {
			types: 'address',
			limit: 1
		};

		// Create Geocoder for Collection Address
		if ($("#collection-address").length) {
			var geocoderCollection = new MapboxGeocoder(options);

			// Attach Geocoder to map and field
			document
				.getElementById("collection-address")
				.appendChild(geocoderCollection.onAdd(map));

			// Append additional attributes to input
			$("#collection-address")
				.find("input")
				.attr('name', 'collection_address')
				.attr('autocomplete', 'new-password');

			// Reverse Geocoding for Collection Address
			if (collection_longitude.val() && collection_latitude.val()) {
				geocoderCollection
					.mapboxClient
					.geocodeReverse({
						longitude: Number(collection_longitude.val()),
						latitude: Number(collection_latitude.val())
					}, limits, function (error, result) {
						try {
							var address = result.features[0].place_name;
						} catch (error) {
							var address = "Address Not Found";
						}

						if (!$("#collection-address").hasClass("d-none")) {
							$("#collection-address")
								.find("input")
								.val(address);
						} else {
							$("[data-geocoder='collection']").text(address);
						}
					});
			} else if (dropoff_longitude.val() || dropoff_latitude.val()) {
				if (!$("#collection-address").hasClass("d-none")) {
					$("#collection-address")
						.find("input")
						.val("Collection Not Set");
				} else {
					$("[data-geocoder='collection']").text("Collection Not Set");
				}
			}

			// For Company's Location Address
			if ($("#collection-address").hasClass("location-address")) {
				var value = $('#address-input').val();
				
				$("#collection-address")
					.find("input")
					.val(value);
			}
		}

		// Create Geocoder for Dropoff Address
		if ($("#dropoff-address").length) {
			var geocoderDropoff = new MapboxGeocoder(options);

			// Attach Geocoder to map and field
			document
				.getElementById("dropoff-address")
				.appendChild(geocoderDropoff.onAdd(map));

			// Append additional attributes to input
			$("#dropoff-address")
				.find("input")
				.attr('name', 'dropoff_address')
				.attr('autocomplete', 'new-password');

			// Reverse Geocoding for Dropoff Address
			if (dropoff_longitude.val() && dropoff_latitude.val()) {
				geocoderDropoff
					.mapboxClient
					.geocodeReverse({
						longitude: Number(dropoff_longitude.val()),
						latitude: Number(dropoff_latitude.val())
					}, limits, function (error, result) {
						try {
							var address = result.features[0].place_name;
						} catch (error) {
							var address = "Address Not Found";
						}

						if (!$("#dropoff-address").hasClass("d-none")) {
							$("#dropoff-address")
								.find("input")
								.val(address);
						} else {
							$("[data-geocoder='dropoff']").text(address);
						}
					});
			}
		}

		// After the map style has loaded on the page, add a source layer and default styling for the points
		map.on("load", function() {
			// Callback function when sourcedata is triggered
			map.on('sourcedata', sourceCallback);

			// Default source structure
			var source = {
				type: "geojson",
				data: {
					type: "FeatureCollection",
					features: []
				}
			};

			// Default layout properties for icons and text
			var properties = {
				"text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
				"text-offset": [0, 0.6],
				"text-anchor": "top",
				"icon-allow-overlap": true,
				"text-allow-overlap": true
			};

			// Default paint options to colour text
			var paint = {
				"text-color": "#000000",
				"text-halo-color": "rgba(255, 255, 255, 1)",
				"text-halo-width": 1
			};

			// Add a source for collection and dropoff
			map.addSource("collection-point", source);
			map.addSource("dropoff-point", source);
			map.addSource("proof-point", source);

			// Add a layer for collection point
			const collection = Object.assign(
				{ "icon-image": "circle-15", "text-field": "Collection" },
				properties
			);
			map.addLayer({
				id: "collection",
				type: "symbol",
				source: "collection-point",
				layout: collection,
				paint: paint
			});

			// Add a layer for dropoff point
			const dropoff = Object.assign(
				{ "icon-image": "circle-stroked-15", "text-field": "Drop-off" },
				properties
			);
			map.addLayer({
				id: "dropoff",
				type: "symbol",
				source: "dropoff-point",
				layout: dropoff,
				paint: paint
			});

			// Add a layer for proof point
			const proof = Object.assign(
				{ "icon-image": "attraction-15", "text-field": "Proof of Delivery" },
				properties
			);
			map.addLayer({
				id: "proof",
				type: "symbol",
				source: "proof-point",
				layout: proof,
				paint: paint
			});

			// If creating a job, add in the default address
			if ($("#collection-address").hasClass("has-default")) {
				$('#location').change();
				// Adjust the click number to plot drop-off next
				clickNumber = 1;
			}

			// Plot Current Collection Point if it Exists
			if (collection_longitude.val() && collection_latitude.val()) {
				var geometry = { type: "Point", coordinates: [collection_longitude.val(), collection_latitude.val()] };
				map.getSource("collection-point").setData(geometry);
			}
			
			// Plot Current Dropoff Point if it Exists
			if (dropoff_longitude.val() && dropoff_latitude.val()) {
				var geometry = { type: "Point", coordinates: [dropoff_longitude.val(), dropoff_latitude.val()] };
				map.getSource("dropoff-point").setData(geometry);
			}

			// Plot Proof of Delivery Point if it Exists
			if ($("#map").data("proof")) {
				var data = { id: $("#map").data("proof"), type: "pod", token: $("#map").data("token") };
				var proofURL = `${apiURL}/mapi/${data.token}/location/${data.type}/${data.id}`;
				map.getSource("proof-point").setData(proofURL);
				// TODO: Jump to proof of delivery coordinates instead
				map.jumpTo({ center: [dropoff_longitude.val(), dropoff_latitude.val()] });
			}

			// Plot the Collection Marker on Selection
			if ($("#collection-address").length)
			geocoderCollection.on("result", function(ev) {

				// For Company's Location Address
				if ($("#collection-address").hasClass("location-address")) {
					var value = $("#collection-address")
						.find("input")
						.val();

					$('#address-input').val(value);
				}

				collection_longitude.val(ev.result.geometry.coordinates[0]);
				collection_latitude.val(ev.result.geometry.coordinates[1]);

				map.getSource("collection-point").setData(ev.result.geometry);

				// Let next click be drop-off
				clickNumber = 1;
			});

			// Plot the Drop-off Marker on Selection
			if ($("#dropoff-address").length)
			geocoderDropoff.on("result", function(ev) {
				dropoff_longitude.val(ev.result.geometry.coordinates[0]);
				dropoff_latitude.val(ev.result.geometry.coordinates[1]);
				
				map.getSource("dropoff-point").setData(ev.result.geometry);

				// Let next click be collection
				clickNumber = 0;
			});

			// Plot the points on click
			if ($("#map").hasClass("interactable"))
			map.on('click', function (ev) {
				clickNumber++;

				// Create the data to add to source
				var geometry = { type: "Point", coordinates: [ev.lngLat.lng, ev.lngLat.lat] };

				// If an odd amount of clicks plot the collection, else plot the dropoff
				if (clickNumber % 2 != 0) {
					collection_longitude.val(ev.lngLat.lng);
					collection_latitude.val(ev.lngLat.lat);

					map.getSource("collection-point").setData(geometry);

					geocoderCollection.mapboxClient.geocodeReverse({
							longitude: ev.lngLat.lng,
							latitude: ev.lngLat.lat
						},
						limits,
						function(error, result) {
							try {
								var address = result.features[0].place_name;
							} catch (error) {
								var address = "Address Not Found";
							}

							$("#collection-address")
								.find("input")
								.val(address);
						}
					);
				} else {
					dropoff_longitude.val(ev.lngLat.lng);
					dropoff_latitude.val(ev.lngLat.lat);

					map.getSource("dropoff-point").setData(geometry);

					geocoderDropoff.mapboxClient.geocodeReverse({
						longitude: ev.lngLat.lng,
						latitude: ev.lngLat.lat
					},
						limits,
						function (error, result) {
							try {
								var address = result.features[0].place_name;
							} catch (error) {
								var address = "Address Not Found";
							}

							$("#dropoff-address")
								.find("input")
								.val(address);
						}
					);
				}
			});

			// Check if the map has been clicked
			var clicked = false;
			map.on('mousedown', function (e) {
				clicked = true;
			});

			// Load "Available" Image
			map.loadImage('/images/maps/green.png', function (error, image) {
				if (error) throw error;
				map.addImage('available', image);
			});

			// Load "Not Available (On Job)" Image
			map.loadImage('/images/maps/blue.png', function (error, image) {
				if (error) throw error;
				map.addImage('unavailable', image);
			});

			// Load "Disconnecting" Image
			map.loadImage('/images/maps/red.png', function (error, image) {
				if (error) throw error;
				map.addImage("disconnecting", image);
			});

			// Load "Offline" Image
			map.loadImage('/images/maps/grey.png', function (error, image) {
				if (error) throw error;
				map.addImage('offline', image);
			});

			// Check if an asset needs to be displayed on the map
			if ($("#map").data("asset") || $("#map").data("job")) {
				// Get Asset ID or Job ID
				if ($("#map").data("asset")) {
					var data = { id: $("#map").data("asset"), type: "asset", token: $("#map").data("token")  };
				} else if ($("#map").data("job")) {
					var data = { id: $("#map").data("job"), type: "job", token: $("#map").data("token")  };
				}

				// Set up routes for getting asset location and route data
				var locationURL = `${apiURL}/mapi/${data.token}/location/${data.type}/${data.id}`;
				var routeURL = `${apiURL}/mapi/${data.token}/route/${data.type}/${data.id}`;

				// Add a source for asset location and route data
				map.addSource("route-data", source);
				map.addSource("asset-location", source);

				// Add a layer for route data
				map.addLayer({
					id: "route",
					type: "line",
					source: "route-data",
					layout: {
						"line-join": "round",
						"line-cap": "round"
					},
					paint: {
						"line-color": "yellow",
						"line-width": 8
					}
				});

				// Add a layer for asset location if not the report page
				if (!$("#map").hasClass("report")) {
					const asset = Object.assign({ "icon-image": "{status}", "text-field": "{title}", "icon-rotate": { type: 'identity', property: 'rotate' } }, properties);
					map.addLayer({
						id: "asset",
						type: "symbol",
						source: "asset-location",
						layout: asset,
						paint: paint
					});

					// Create a popup for the asset
					createPopups("asset");
				}

				// Set an interval to constantly get current location of asset unless it is the report page
				setLiveAssetData();
				if (!$("#map").hasClass("report")) {
					window.setInterval(setLiveAssetData, mapInterval);
				}

				function setLiveAssetData() {
					map.getSource("asset-location").setData(locationURL);
					map.getSource("route-data").setData(routeURL);

					// If the map hasn't been clicked keep centering on the asset's location
					if (!clicked) {
						d3.json(locationURL, function(error, data) {
							if (error) throw error;
							if (!$("#map").hasClass("report")) {
								map.jumpTo({ center: data.geometry.coordinates });
							}
						});
					}
				}
			}
			
			// Check if all assets need to be displayed on the map
			if ($("#map").data("type") == "all") {
				// Get URL for all asset tracking
				var token = $("#map").data("token");
				var liveURL = `${apiURL}/mapi/${token}/live`;

				// Add a source for asset location and route data
				map.addSource("live-assets", source);

				// Add a layer for all assets
				const assets = Object.assign({ "icon-image": "{status}", "text-field": "{title}", "icon-rotate": { type: 'identity', property: 'rotate' } }, properties);
				map.addLayer({
					id: "assets",
					type: "symbol",
					source: "live-assets",
					layout: assets,
					paint: paint
				});

				// Create popups for assets
				createPopups("assets");

				// Allow filtering of dates for all asset tracking
				var filterChangeHandler = function() {
					// Clear the old asset location update if it exists
					clearInterval(window.update);

					if ($("#filter").val()) {
						// Get an updated URL and update the map
						var filteredURL = `${apiURL}/mapi/${token}/live?date=${$(this).val()}`;
						map.getSource("live-assets").setData(filteredURL);
					} else {
						// If date is empty, continue live tracking as normal
						map.getSource("live-assets").setData(liveURL);
						window.update = window.setInterval(function () {
							map.getSource("live-assets").setData(liveURL);
						}, mapInterval);
					}
				}

				// Assign the filter change handler to the filter
				$("#filter").on("dp.change", filterChangeHandler);
				filterChangeHandler();
			}
		});

		// When the location gets changed update the collection address
		$('#location').on('change', function () {
			getAndUpdateLocationAddress($(this).val());
		}); 

		// Callback function when source is loaded
		function sourceCallback(e) {
			if (window.location.pathname.includes("create")) {
				if (collectionDefaultSet != true) {
					if (e.sourceId === "collection-point") {
						if (map.getSource('collection-point') && map.isSourceLoaded('collection-point')) {
							getAndUpdateLocationAddress($('#location').val());
						}
					}
				}
			}
		}

		// Function to create popups for assets
		function createPopups(layer) {
			// Create a popup when the mouse hovers over an asset
			map.on("mouseenter", layer, function (e) {
				// Get details for the popup
				var coordinates = e.features[0].geometry.coordinates.slice();
				var details = JSON.parse(e.features[0].properties.details);

				// Append Details to Popup
				popup
					.setLngLat(coordinates)
					.setHTML(
						"<b>Driver:</b> " + details.driver + "<hr>" +
						"<b>Phone Number:</b> " + details.number + "<hr>" +
						"<b>Asset:</b> " + details.asset + "<hr>" +
						"<b>Coordinates:</b> " + coordinates + "<hr>" +
						"<b>Last Seen:</b> " + details.seen + "<hr>" +
						"<b>Current Job:</b> " + details.job
					)
					.addTo(map);
			});

			map.on("mouseleave", layer, function(e) {
				popup.remove();
			});
        }

        // When a coordinate has been manually changed
        collection_longitude.on('change', function (e) {
            if (e.originalEvent) {
                updateAddressField("collection");
            }
        });
        collection_latitude.on('change', function (e) {
            if (e.originalEvent) {
                updateAddressField("collection");
            }
        });
        dropoff_longitude.on('change', function (e) {
            if (e.originalEvent) {
                updateAddressField("dropoff");
            }
        });
        dropoff_latitude.on('change', function (e) {
            if (e.originalEvent) {
                updateAddressField("dropoff");
            }
        });
        
        // When a longitutde and latitude have been set, reverse geocode the result
        function updateAddressField(type) {
            if (type === "collection") {
                if (!collection_longitude.val() && !collection_latitude.val()) {
                    $("input[name='collection_address']").val('');
                    map.getSource('collection-point').setData({
                        "type": "LineString",
                        "coordinates": [[0, 0], [0, 0]]
                    });
                }

                if (!collection_longitude.val() || !collection_latitude.val()) {
                    return;
                }

                geocoderCollection.mapboxClient.geocodeReverse({
                    longitude: Number(collection_longitude.val()),
                    latitude: Number(collection_latitude.val())
                },
                limits,
                function (error, result) {
                    try {
                        var address = result.features[0].place_name;
                    } catch (error) {
                        var address = "Address Not Found";
                    }

                    $("input[name='collection_address']").val(address);

                    var geometry = { type: "Point", coordinates: [collection_longitude.val(), collection_latitude.val()] };
                    map.getSource("collection-point").setData(geometry);
                    map.flyTo({ center: geometry.coordinates });
                });
            } else if (type === "dropoff") {
                if (!dropoff_longitude.val() && !dropoff_latitude.val()) {
                    $("input[name='dropoff_address']").val('');
                    map.getSource('dropoff-point').setData({
                        "type": "LineString",
                        "coordinates": [[0, 0], [0, 0]]
                    });
                }

                if (!dropoff_longitude.val() || !dropoff_latitude.val()) {
                    return;
                }

                geocoderDropoff.mapboxClient.geocodeReverse({
                    longitude: Number(dropoff_longitude.val()),
                    latitude: Number(dropoff_latitude.val())
                },
                limits,
                function (error, result) {
                    try {
                        var address = result.features[0].place_name;
                    } catch (error) {
                        var address = "Address Not Found";
                    }

                    $("input[name='dropoff_address']").val(address);

                    var geometry = { type: "Point", coordinates: [dropoff_longitude.val(), dropoff_latitude.val()] };
                    map.getSource("dropoff-point").setData(geometry);
                    map.flyTo({ center: geometry.coordinates });
                });
            }
        }

		// Update the collection address when a location is changed
		function getAndUpdateLocationAddress(id = null) {
			// Exit out if the source has not yet been loaded
			if (!map.getSource("collection-point")) {
				return
			}

			var addressURL = id != null ? "/admin/locations/" + id + "/address" : "/admin/settings/collection-address";

			$.ajax({
				type: "GET",
				url: addressURL,
				datatype: "json",
				async: false,
				success: function (data) {
					address = data;
				}
			});

			// Change global variable for check to true
			collectionDefaultSet = true;

			geocoderCollection
				.mapboxClient
				.geocodeForward(address, limits, function (error, result) {
					$("#collection-address")
						.find("input")
						.val(address);

						if ($("#collection-address").hasClass("location-address")) {
							$('#address-input').val(address);
						}

					if (result.features[0]) {
						// Fill in the coordinate hidden fields
						collection_longitude.val(result.features[0].geometry.coordinates[0]);
						collection_latitude.val(result.features[0].geometry.coordinates[1]);

						// Plot the coordinate on the map
						map.getSource("collection-point").setData(result.features[0].geometry);

						// Fly to the coordinates
						map.flyTo({ center: result.features[0].geometry.coordinates });
					} else {
						$("#collection-address")
							.find("input")
							.val("Address Not Found");
					}
				});
		}

		// Clear the address fields (collection & dropoff)
		$('#clear-addresses').click(function () {
			$("input[name='collection_address']").val('');
			$("input[name='dropoff_address']").val('');
			collection_latitude.val('');
			collection_longitude.val('');
			dropoff_latitude.val('');
			dropoff_longitude.val('');

			map.getSource('collection-point').setData({ 
				"type": "LineString",
				"coordinates": [[0,0], [0,0]]
			});
			map.getSource('dropoff-point').setData({ 
				"type": "LineString",
				"coordinates": [[0, 0], [0, 0]]
			});
		});
	}
});


// WEBPACK FOOTER //
// ./resources/assets/js/maps.js